// src/CustomsFeed.js
import React, { useState, useEffect, useCallback } from 'react'; // (แก้ไข 1: ลบ useCallback ที่ไม่ได้ใช้ออก)
import axios from 'axios';
import toast from 'react-hot-toast';

const API_URL = 'https://rys-backend.onrender.com/api';

// --- (1. กำหนดค่าเริ่มต้นที่คุณต้องการ) ---
// (คุณสามารถเปลี่ยน "ประกาศกรม" เป็นชื่อ Topic อื่นที่คุณต้องการได้)
const DEFAULT_MINISTRY_NAME = "กระทรวงการคลัง";
const DEFAULT_AGENCY_NAME = "กรมศุลกากร";
const DEFAULT_TOPIC_NAME = "ประกาศกรม"; 
// ------------------------------------

// --- (อัปเกรด 1) สร้าง "พจนานุกรม" แปลงเดือนไทยเป็นเลข (JS) ---
const THAI_MONTHS = {
  "มกราคม": 0,
  "กุมภาพันธ์": 1,
  "มีนาคม": 2,
  "เมษายน": 3,
  "พฤษภาคม": 4,
  "มิถุนายน": 5,
  "กรกฎาคม": 6,
  "สิงหาคม": 7,
  "กันยายน": 8,
  "ตุลาคม": 9,
  "พฤศจิกายน": 10,
  "ธันวาคม": 11
};

// --- (อัปเกรด 2) ฟังก์ชัน isToday (เวอร์ชันอ่านภาษาไทย) ---
/**
 * ตรวจสอบว่าวันที่จาก API (DD เดือน YYYY พ.ศ.) ตรงกับวันปัจจุบันหรือไม่
 * @param {string} apiDateString (เช่น "13 พฤศจิกายน 2568")
 * @returns {boolean}
 */
const isToday = (apiDateString) => {
  try {
    if (!apiDateString) return false;
    
    // 1. (สำคัญ) ลบช่องว่าง (whitespace) ทั้งหมดที่อาจติดมา
    const cleanDateString = apiDateString.trim(); 

    // 2. (สำคัญ) ใช้ Regex เพื่อ "ดึง" ส่วนประกอบของวันที่
    //    (\d{1,2})   -> วันที่ (13)
    //    \s+         -> ช่องว่าง
    //    (.+?)       -> ชื่อเดือน (พฤศจิกายน)
    //    \s+         -> ช่องว่าง
    //    (\d{4})     -> ปี พ.ศ. (2568)
    const match = cleanDateString.match(/(\d{1,2})\s+(.+?)\s+(\d{4})/);
    
    if (!match) {
      // (ถ้า Format ไม่ตรง เช่น "13-11-2568" ให้ข้ามไปเลย)
      // console.warn(`isToday: Format ไม่ตรง: "${cleanDateString}"`);
      return false; 
    }

    // 3. แยกส่วน
    const d = parseInt(match[1], 10);
    const monthName = match[2]; // (เช่น "พฤศจิกายน")
    const y_be = parseInt(match[3], 10);

    // 4. (สำคัญ) แปลงชื่อเดือนไทยเป็นตัวเลข (0-11)
    if (y_be < 2500 || !(monthName in THAI_MONTHS)) {
      // console.warn(`isToday: ปี พ.ศ. หรือชื่อเดือนผิดพลาด: "${monthName}", ${y_be}`);
      return false;
    }
    const m_js = THAI_MONTHS[monthName]; // (พฤศจิกายน -> 10)

    // 5. แปลงเป็น ค.ศ. (เช่น 2568 - 543 = 2025)
    // (เราอ้างอิงปี 2560, 2530, 2481 มาแล้ว)
    const y_ce = y_be - 543; 

    // 6. สร้าง Date object ของ "วันนี้" (รีเซ็ตเวลาเป็นเที่ยงคืน)
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // 7. สร้าง Date object ของ "วันที่ใน API" (รีเซ็ตเวลาเป็นเที่ยงคืน)
    const itemDate = new Date(y_ce, m_js, d, 0, 0, 0, 0); 
    
    // 8. (ป้องกัน Bug วันที่ผิดพลาด เช่น 31 กุมภาพันธ์)
    if (itemDate.getDate() !== d || itemDate.getMonth() !== m_js || itemDate.getFullYear() !== y_ce) {
        // console.warn(`isToday: วันที่ไม่ถูกต้อง: D=${d}, M=${monthName}, Y=${y_ce}`);
        return false;
    }
    
    // 9. เปรียบเทียบค่าเวลา (milliseconds)
    return today.getTime() === itemDate.getTime();
    
  } catch (error) {
    console.error("Error in isToday function:", error);
    return false;
  }
};

// (ไอคอน)
const RssIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12.75 19.5v-.75a7.5 7.5 0 0 0-7.5-7.5H4.5m0-6.75h.75c7.87 0 14.25 6.38 14.25 14.25v.75M6 18.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
  </svg>
);

function CustomsFeed() {
  const [feedData, setFeedData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // --- (State สำหรับ Dropdown 3 ระดับ) ---
  const [optionsData, setOptionsData] = useState([]);
  const [selectedMinistryId, setSelectedMinistryId] = useState('');
  const [selectedAgencyId, setSelectedAgencyId] = useState('');
  const [selectedTopicId, setSelectedTopicId] = useState('');

  // (ฟังก์ชันยิง API Scraper - ไม่ต้องใช้ useCallback แล้ว)
  const fetchFeed = useCallback(async (topicId) => {
    if (!topicId) return;
    setIsLoading(true);
    setError(null);
    setFeedData([]);
    try {
      const response = await axios.get(`${API_URL}/scrape-feed?id=${topicId}`);
      setFeedData(response.data);
    } catch (err) {
      const errorMsg = err.response?.data?.msg || 'เกิดข้อผิดพลาดในการดึงข้อมูล';
      setError(errorMsg);
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  }, []);


  // (ดึงข้อมูล Dropdown 3-Tier)
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(`${API_URL}/feed-options-hierarchical`);
        const fetchedOptions = response.data;
        setOptionsData(fetchedOptions);
        const defaultMinistry = fetchedOptions.find(m => m.name === DEFAULT_MINISTRY_NAME);
        
        if (defaultMinistry) {
          const defaultAgency = defaultMinistry.agencies.find(a => a.name === DEFAULT_AGENCY_NAME);
          if (defaultAgency) {
            const defaultTopic = defaultAgency.topics.find(t => t.name === DEFAULT_TOPIC_NAME);
            
            if (defaultTopic) {
              // (D. ตั้งค่า State เริ่มต้น)
              setSelectedMinistryId(defaultMinistry.id.toString());
              setSelectedAgencyId(defaultAgency.id.toString());
              setSelectedTopicId(defaultTopic.id.toString());
              
              // --- (C. ยิง API โหลด Feed ทันที) ---
              fetchFeed(defaultTopic.id.toString()); 
            }
          }
        }
      } catch (err) {
        toast.error('ไม่สามารถโหลดตัวเลือก Feed ได้');
      }
    };
    fetchOptions();
  }, [fetchFeed]); // (เพิ่ม fetchFeed ใน dependency array)

  // (สกัดข้อมูลสำหรับ Dropdown 2 และ 3)
  const agenciesForSelectedMinistry = optionsData.find(
    (m) => m.id === parseInt(selectedMinistryId)
  )?.agencies || []; 

  const topicsForSelectedAgency = agenciesForSelectedMinistry.find(
    (a) => a.id === parseInt(selectedAgencyId)
  )?.topics || []; 

  // (Handlers สำหรับ Dropdown)
  const handleMinistryChange = (e) => {
    setSelectedMinistryId(e.target.value);
    setSelectedAgencyId('');
    setSelectedTopicId('');
    setFeedData([]); 
  };

  const handleAgencyChange = (e) => {
    setSelectedAgencyId(e.target.value);
    setSelectedTopicId('');
    setFeedData([]); 
  };
  
  const handleTopicChange = (e) => {
    const topicId = e.target.value;
    setSelectedTopicId(topicId);
    if (topicId) {
      fetchFeed(topicId);
    } else {
      setFeedData([]); 
    }
  };

  
  // (ฟังก์ชัน Download Proxy)
  const handleDownload = async (item) => {
    if (!item.link || item.link === '#') {
        toast.error('ไม่มีไฟล์แนบสำหรับรายการนี้');
        return;
    }
    const toastId = toast.loading('กำลังเตรียมดาวน์โหลดไฟล์... (ขั้นตอนนี้อาจใช้เวลา 10-15 วินาที)');
    try {
        const response = await axios.get(`${API_URL}/download-proxy`, {
            params: { url: item.link },
            responseType: 'blob', 
        });
        const file = new Blob([response.data], { type: response.headers['content-type'] });
        const fileURL = URL.createObjectURL(file);
        
        let filename = "downloaded_file.pdf"; 
        const contentDisp = response.headers['content-disposition'];
        if (contentDisp && contentDisp.includes('filename=')) {
            filename = contentDisp.split('filename=')[1].trim().replaceAll('"', '');
        }

        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', decodeURIComponent(filename));
        document.body.appendChild(link);
        link.click();
        
        link.parentNode.removeChild(link);
        URL.revokeObjectURL(fileURL);
        
        toast.success('ดาวน์โหลดสำเร็จ!', { id: toastId });
    } catch (err) {
        console.error("Download Error:", err);
        const errorMsg = err.response?.data?.msg || 'ดาวน์โหลดไฟล์ไม่สำเร็จ (ต้นทางอาจป้องกันการเข้าถึง)';
        toast.error(errorMsg, { id: toastId });
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-xl p-6 mb-8">
      <div className="flex items-center gap-4 mb-6 pb-4 border-b">
        <div className="text-blue-600"><RssIcon /></div>
        <h2 className="text-2xl font-semibold text-gray-800">
          Live Feed หน่วยงานราชการด้านศุลกากรและภาษี
        </h2>
      </div>

      {/* --- UI Dropdown 3 ระดับ --- */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        
        {/* 1. Dropdown กระทรวง */}
        <select
          value={selectedMinistryId}
          onChange={handleMinistryChange}
          className="w-full p-3 text-lg border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">1. เลือกกระทรวง...</option>
          {optionsData.map((ministry) => (
            <option key={ministry.id} value={ministry.id}>
              {ministry.name}
            </option>
          ))}
        </select>

        {/* 2. Dropdown หน่วยงาน */}
        <select
          value={selectedAgencyId}
          onChange={handleAgencyChange}
          disabled={!selectedMinistryId || agenciesForSelectedMinistry.length === 0}
          className="w-full p-3 text-lg border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
        >
          <option value="">2. เลือกหน่วยงาน...</option>
          {agenciesForSelectedMinistry.map((agency) => (
            <option key={agency.id} value={agency.id}>
              {agency.name}
            </option>
          ))}
        </select>

        {/* 3. Dropdown หัวข้อ */}
        <select
          value={selectedTopicId}
          onChange={handleTopicChange}
          disabled={!selectedAgencyId || topicsForSelectedAgency.length === 0}
          className="w-full p-3 text-lg border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
        >
          <option value="">3. เลือกหัวข้อเอกสาร...</option>
          {topicsForSelectedAgency.map((topic) => (
            <option key={topic.id} value={topic.id}>
              {topic.name}
            </option>
          ))}
        </select>
      </div>

      {/* --- (ส่วนแสดงผลตาราง) --- */}
      {isLoading && <p className="text-center text-lg text-gray-600">กำลังโหลดข้อมูล...</p>}
      {error && <p className="text-center text-lg text-red-600">{error}</p>}
      
      {!isLoading && !error && feedData.length > 0 && (
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-slate-50">
            <tr>
              <th className="px-6 py-3 text-left text-base font-medium text-gray-500 uppercase">วันที่</th>
              <th className="px-6 py-3 text-left text-base font-medium text-gray-500 uppercase">เลขที่เอกสาร</th>
              <th className="px-6 py-3 text-left text-base font-medium text-gray-500 uppercase">รายละเอียด</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {feedData.map((item, index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-lg text-gray-600">{item.date}</td>
                <td className="px-6 py-4 whitespace-nowrap text-lg text-gray-800">{item.doc_no}</td>
                
                {/* --- (ส่วนแสดงผลรายละเอียด) --- */}
                <td className="px-6 py-4 text-lg text-gray-900">
                  <button 
                    onClick={() => handleDownload(item)} 
                    className="text-blue-600 hover:text-blue-800 hover:underline text-left"
                  >
                    {item.details}
                  </button>
                  
                  {/* (โค้ดสำหรับแสดง "NEW" Badge - ไม่มีการแก้ไข) */}
                  {isToday(item.date) && (
                    <span className="ml-3 inline-flex items-center rounded-md bg-green-100 px-3 py-1 text-base font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                      NEW
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      
      {!isLoading && !error && feedData.length === 0 && selectedTopicId && (
        <p className="text-center text-lg text-gray-500">ไม่พบข้อมูลสำหรับหัวข้อนี้</p>
      )}

    </div>
  );
}

export default CustomsFeed;